/**
 * Form data reader
 * @constructor
 * @see https://github.com/jquery/jquery/blob/master/src/serialize.js
 */
function FormDataReader(){

}

/**
 * Read data set from the provided form
 * @see http://www.w3.org/TR/html5/forms.html#constructing-form-data-set
 */
FormDataReader.getEntries = function getEntries(form){
	this._data = null;
	var dataSet = [];
	for(var type, name, nodeName, value, element, elementIndex = 0, numElements = form.elements.length; elementIndex < numElements; elementIndex++){
		element = form.elements[elementIndex];
		type = element.type;
		name = element.name;
		nodeName = element.nodeName;

		if(
			!(
				// http://www.w3.org/TR/html5/forms.html#concept-fe-disabled
				nodeName == "FIELDSET" || nodeName == "OUTPUT"// fieldset and output are included in form.elements http://www.w3.org/TR/html5/forms.html#category-listed
				// The field element is disabled.
				|| element.matches(":disabled") // test element.disabled and test if fieldset ancestors are not disabled
				//http://www.w3.org/TR/html5/forms.html#category-submit
				// Submitters
				|| nodeName == "BUTTON"
				|| nodeName == "INPUT" && type == "reset"
				|| nodeName == "INPUT" && type == "submit"
				|| nodeName == "INPUT" && type == "image"
				// The field element is an input element whose type attribute is in the Radio Button and Checkbox state and whose checkedness is false.
				|| (nodeName == "INPUT" && type == "checkbox" && type == "radio" && !element.checked)
				// no name or empty string.
				|| !name
				// object not used by a plugin.
				|| (nodeName == "OBJECT")//TODO Detect if element that is not using a plugin: http://www.w3.org/TR/html5/infrastructure.html#plugin
				)
			){
			// Select
			if(nodeName == "SELECT"){
				for(var option, optionIndex = 0, numOptions = element.selectedOptions.length; optionIndex < numOptions; optionIndex++){
					option = element.selectedOptions[optionIndex];
					// Is not a disabled option or in a disabled option group
					if(!option.matches(":disabled"))
					// or use: `!option.disabled && !(option.parentNode.nodeName == "OPTGROUP" || option.parentNode.disabled)`
					{
						dataSet.push(new FormDataEntry(name, option.value, type));
					}
				}
			}
			// Checkbox and radio
			else if(nodeName == "INPUT" && (type == "radio" || type == "checkbox")) {
				// Some browsers don't have default value "on". But still exist ?
				// http://stackoverflow.com/questions/4305456/webkit-checkbox-default-value-is-null
				// https://github.com/WebKit/webkit/blob/master/LayoutTests/fast/forms/checkbox-default-value.html
				// element.getAttribute("value") === null ? "on" : element.value
				dataSet.push(new FormDataEntry(name, element.value, type));
			}
			// Files
			else if(nodeName == "INPUT" && type == "file") {
				var fileIndex = 0, numFiles = element.files.length;
				for(fileIndex = 0; fileIndex < numFiles; fileIndex++){
					dataSet.push(new FormDataEntry(name, element.files[fileIndex], type));
				}
				if(numFiles == 0){
					dataSet.push(new FormDataEntry(name, "", "application/octet-stream"));
				}
			}
			//
			else if(nodeName == "OBJECT") {
				// obtainable value from plugin
				//if(false){
				dataSet.push(new FormDataEntry(name, "%plugin value%", "object"));
				//}
			}
			// Others
			else {
				if((nodeName == "TEXTAREA" || nodeName == "INPUT" && (type == "text" || type == "search")) && element.hasAttribute("dirname") && element.dirName){
					// element.dir don't give any value
					dataSet.push(
						new FormDataEntry(
							element.dirName,
							element.matches(":dir(rtl)") ? "rtl" : "ltr",
							"direction"
						)
					);
				}
				dataSet.push(
					new FormDataEntry(
						name,
						nodeName == "TEXTAREA" ? element.value : element.value,
						type
					)
				);
			}
		}
	}

	return dataSet;
};

/**
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/FormData
 * @param {Array.<Object>|HTMLFormElement} entries
 * @param {FormData} [data]
 * @returns {FormData}
 */
FormDataReader.toFormData = function toFormData(entries, data){
	// If entries is a form and data not defined, just return the FormData of the form
	if(entries instanceof HTMLFormElement && !(data instanceof FormData)){
		return new FormData(entries);
	}

	data = data instanceof FormData ? data : new FormData();
	for(var entry, entryIndex = 0, numEntries = entries.length; entryIndex < numEntries; entryIndex++){
		entry = entries[entryIndex];
		data.append(entry.name, entry.value);
	}
	return data;
};

/**
 * @class FormDataEntry
 * @param {String} name
 * @param {*} value
 * @param {String} type
 */
function FormDataEntry(name, value, type){
	this.name = name;
	this.value = value;
	this.type = type;
}